import {Link, useParams} from "react-router-dom";
import {fetchWithToken} from "../../api/apiBase";
import {useAuthInfo} from "@propelauth/react";
import React, {useState} from "react";
import {BaseScopeModel, DeveloperScopeCardModel} from "./ScopeModel";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";

type DeveloperScopeCardProps = {
    scope: DeveloperScopeCardModel
}

type ScopeCardProps = {
    scope: BaseScopeModel
}

/*
* What do we want to see here??
* NUmber of bidders invited.
* Number of bids
*
* */
export function DeveloperScopeCard({scope}: DeveloperScopeCardProps) {

    const {project_id} = useParams<string>();
    console.log(scope);
    return (
        <Card key={scope.id} className="mb-4">
            <CardHeader>
                <CardTitle className="flex justify-between items-center">
                    <Link
                        className="text-lg font-semibold"
                        to={`/project/${project_id}/scopes/${scope.id}`}
                    >
                        #{scope.number} - {scope.title}
                    </Link>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div>
                    <div className="text-base mb-2">{scope.description}</div>
                    <div className="columns-2 ">
                        <p>Invited Bidders</p>
                        <p className="text-base mb-2">{scope.num_bidders}</p>
                    </div>
                    <div className="columns-2 ">
                        <p>Submitted Bids</p>
                        <p className="text-base mb-2">{scope.num_bids}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

export function BidderScopeCard({scope}: ScopeCardProps) {

    const {project_id} = useParams<string>();

    return (
        <Card key={scope.id} className="mb-4">
            <CardHeader>
                <CardTitle className="flex justify-between items-center">
                    <Link
                        className="text-lg font-semibold"
                        to={`/project/${project_id}/scopes/${scope.id}`}
                    >
                        #{scope.number} - {scope.title}
                    </Link>
                    {/*<QAControls<QAModel>*/}
                    {/*    controls={controls}*/}
                    {/*    qa={qa}*/}
                    {/*    onEdit={onEdit}*/}
                    {/*/>*/}
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-base mb-2">{scope.description}</div>

            </CardContent>
        </Card>
    );
}